module.exports = {
    Simple: require('./simple'),
    SpatialHash: require('./spatial-hash')
}